<template>
  <div v-if="data">
    <form-control
      v-for="site in Object.keys(data).filter((v) => ['id', 'created_at', 'updated_at'].indexOf(v) === -1)"
      :key="site"
      v-model="data[site]"
      :title="capitalize(site)"
    />
  </div>
</template>
<script>

const getDefault = () => {
  return {
    facebook: null,
    twitter: null,
    youtube: null,
    skype: null,
    linkedin: null,
  }
}

export default {
  props: {
    value: {
      required: false,
      type: Object,
      default () {
        return getDefault()
      },
    },
  },

  data () {
    return {
      data: null,
    }
  },

  watch: {
    value () {
      this.data = this.value || getDefault()
    },
    data () {
      this.$emit('input', this.data)
    },
  },

  mounted () {
    if (this.value) {
      this.data = this.value
    } else {
      this.data = getDefault()
    }
  },

  methods: {
    capitalize (v) {
      if (v) {
        return v.substring(0, 1).toUpperCase() + v.substring(1)
      }
    },
  },
}
</script>
